<div
  *ngrxLet="vm$ as vm"
  class="buy-button-container"
  [ngClass]="{
    'is-pending': vm.isPending
  }"
  [class]="vm.theme ? 'theme--' + vm.theme : ''"
>
  <div class="button-wrapper">
    <div class="brush"></div>
    <button
      [disabled]="vm.disabled"
      (click)="submit.emit()"
      [attr.data-e2e]="'order:submit:button'"
      [class.ds-button]="vm.theme === 'default'"
      [class.primary]="vm.theme === 'default'"
    >
      <div class="button-icon-container left-icon" *ngIf="vm.iconLeft">
        <i class="fa {{ vm.iconLeft }}"></i>
      </div>
      <div class="button-inner">
        <span *ngIf="vm.translationModeActive; else buyButtonText" data-editor-target="btnText" data-editor-targetable>
          <span [innerHTML]="vm.customText"></span>
        </span>
        <ng-template #buyButtonText>
          <span [innerHTML]="vm.text"> </span>
        </ng-template>
      </div>
      <div class="button-icon-container right-icon" *ngIf="vm.iconRight">
        <i class="fa {{ vm.iconRight }}"></i>
      </div>
    </button>
    <orderform-guarantee-seal *ngIf="vm.sealType" [art]="vm.sealType"></orderform-guarantee-seal>
  </div>
</div>
